<ng-container *ngIf="alerts">
	<section>
		<goa-error-bar *ngIf="bullets && alerts?.length > 0 && alerts[0].alertType == 'error'; else otherNotifications">
			{{ caption }}
			<ul>
				<li *ngFor="let error of alerts">{{ error.description }}</li>
			</ul>
		</goa-error-bar>
	</section>
	<ng-template #otherNotifications>
		<section>
			<div class="notifications">
				<div
					class="notification"
					[class.notification-error]="e.alertType == 'error' || e.alertType == 'critical'"
					[class.notification-warning]="e.alertType == 'warning'"
					[class.notification-info]="e.alertType == 'info'"
					[class.notification-success]="e.alertType == 'success'"
					[class.notification-todo]="e.alertType == 'todo'"
					*ngFor="let e of alerts"
				>
					<mat-icon *ngIf="e.alertType == 'error' || e.alertType == 'critical'">error_outline</mat-icon>
					<mat-icon *ngIf="e.alertType == 'warning'">report_problem</mat-icon>
					<mat-icon *ngIf="e.alertType == 'info'">info</mat-icon>
					<mat-icon *ngIf="e.alertType == 'success'">check_circle</mat-icon>
					<mat-icon *ngIf="e.alertType == 'todo'">lightbulb</mat-icon>
					{{ e.description }}
				</div>
			</div>
		</section>
	</ng-template>
</ng-container>
